import {
  createLogger,
  initLogger as initLoggerJs
} from 'logger-js'
import { APP_GLOBAL_KEY } from 'modules/app/constants'
import { PRODUCTION } from 'modules/environment/constants'
import createReduxStore from 'modules/redux'
import updateSearchAction from 'modules/search/actions/update-search'
import updateViewportAction from 'modules/viewport/actions/update'
import createViewportUtil from 'modules/viewport/utils/create'
import {
  initLogger,
  logUtil
} from 'packages/src'
import { hydrateRoot } from 'react-dom/client'
import getQuerySearchSelect from 'modules/search/selectors/get-query'
import renderAppClientUtil from 'client/utils/render-app/index.jsx'
import { isBotUserAgentUtil } from 'modules/user-agent/utils/is-bot/index.js'
import { getWidthViewportSelect } from 'modules/viewport/selectors/index.js'

const level = PRODUCTION
  ? 'info'
  : 'debug'

initLoggerJs({
  level
})

initLogger({
  level
})

const logger = createLogger({
  label: 'client'
})

if (DEVELOPMENT) {
  const webVitals = require('web-vitals')
  const getCLS = webVitals.getCLS
  const getFID = webVitals.getFID
  const getLCP = webVitals.getLCP
  getCLS(console.log)
  getFID(console.log)
  getLCP(console.log)
}

let store

function updateViewport () {
  store.dispatch(updateViewportAction())
}

function onResizeViewport () {
  updateViewport()
}

function initViewport () {
  window.addEventListener(
    'resize',
    onResizeViewport
  )
  window.addEventListener(
    'orientationchange',
    onResizeViewport
  )
  const viewport = createViewportUtil()
  const state = store.getState()

  // if (isSmallScreenViewportUtil(viewport) !== isSmallScreenViewportSelect(state)) {
  //   updateViewport()
  // }
  if (
    !isBotUserAgentUtil() &&
    viewport.width !== getWidthViewportSelect(state)
  ) {
    updateViewport()
  }
}

function initSearch () {
  const query = getQuerySearchSelect(store.getState())
  if (!query) {
    return
  }

  store.dispatch(updateSearchAction(decodeURI(query)))
}

function beforeHydrate () {
  initViewport()
  initSearch()
}

async function run () {
  const storeAndHistory = await createReduxStore(
    window[APP_GLOBAL_KEY.INITIAL_STATE]
  )
  store = storeAndHistory.store
  const history = storeAndHistory.history
  delete window[APP_GLOBAL_KEY.INITIAL_STATE]

  const props = {
    history
  }

  beforeHydrate()

  hydrateRoot(
    document.getElementById('root'),
    renderAppClientUtil(store, props)
  )

  if (
    window.lazySizes &&
    !isBotUserAgentUtil()
  ) {
    window.lazySizes.init()
    // document.addEventListener('lazybeforeunveil', e => console.log('[lz] beforeunveil', e.target))
    // document.addEventListener('lazyunveilread', e => console.log('[lz] unveilread', e.detail))
    // document.addEventListener('lazyloaded', e => console.log('[lz] loaded', e.target))
  }

  if (!isBotUserAgentUtil()) {
    try {
      onResizeViewport()
      const afterInitClientHookAction = await import(/* webpackChunkName: "client/hooks/after-init" */ 'client/hooks/after-init')
      return store.dispatch(
        afterInitClientHookAction.default()
      )
    } catch (error) {
      logUtil('run').error('error=', error)
    }
  }
}

function main () {
  run()
}

window.addEventListener(
  'load',
  function () {
    try {
      main()
    } catch (error) {
      logger.error(
        'starting application failed: ',
        error
      )
    }
  }
)
